import { useTranslation } from "react-i18next"
import { CardBodyHeader, CardBodyHeaderTitle } from "@/components/ui/card"
import { isRecommendedMedicationsEmpty } from "@/modules/patients/detail/progress-note/lib/is-recommended-medications-empty"
import { ProgressNoteData } from "@/modules/patients/detail/progress-note/types/progress-note-fragment-type"
import { RecommendedMedicationList } from "@/modules/patients/detail/recommended-medications/components/recommended-medication-list"

export const RecommendedMedicationsReadonlySection = (props: { progressNote: ProgressNoteData }) => {
  const { t } = useTranslation()
  const isEmpty = isRecommendedMedicationsEmpty(props.progressNote)

  if (isEmpty) {
    return null
  }

  return (
    <>
      <CardBodyHeader data-testid="recommended-medications-title">
        <CardBodyHeaderTitle>{t("episodeOfCare.progressNote.recommendedMedications")}</CardBodyHeaderTitle>
      </CardBodyHeader>
      <RecommendedMedicationList progressNote={props.progressNote} />
    </>
  )
}
